import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import { ReactComponent as FeedbackIcon } from '../../design-system/design_system/assets/icons/system/feedback.svg';
import FeedbackRating from './FeedbackRating';
import Chat from './Chat';

const Feedback = (props) => {
  const [feedback, setFeedback] = useState(false);
  const {
    onlineButtonId, offlineButtonId, reactiveButtonId, footerContentInfo, footerType,
  } = props;

  const closeFeedBack = (value) => {
    setFeedback(value);
  };
  const feedbackClickToChat = get(footerContentInfo, 'FeedBackContainer');
  const chatBtndata=get(footerContentInfo,'ChatContainer')
  return (
    <React.Fragment>
      <div className={cx({ 'd-md-block': !(footerType === 'search' || footerType === 'RDsearch') }, 'd-none d-print-none')}>
        <Chat onlineButtonId={onlineButtonId} offlineButtonId={offlineButtonId} reactiveButtonId={reactiveButtonId} feedbackClickToChat={chatBtndata} />
        {(!feedback) && (
        <section className="feedback-container shadow-2">
          <Button variant="ghost" className="border-0 feedback-icon bg-white" onClick={() => setFeedback(!feedback)} data-testid="feed-back-close-button">
            <FeedbackIcon className="agent-icon svg-fill-primary" />
            <span className="feedback p-2">{get(feedbackClickToChat, 'FeedbackText')}</span>
          </Button>
        </section>
        )}
      </div>
      {feedback && (
        <FeedbackRating closeFeedBack={closeFeedBack} />
      )}
    </React.Fragment>
  );
};

Feedback.propTypes = {
  onlineButtonId: PropTypes.string,
  offlineButtonId: PropTypes.string,
  reactiveButtonId: PropTypes.string,
  footerType: PropTypes.string.isRequired,
  footerContentInfo: PropTypes.instanceOf(Object).isRequired,
};

Feedback.defaultProps = {
  reactiveButtonId: '',
  offlineButtonId: '',
  onlineButtonId: '',
};


const mapStateToProps = state => ({
  footerContentInfo: state.CommonReducer.footerData
});
export default connect(
  mapStateToProps,
  null,
)(Feedback);
